export default __webpack_public_path__ + "static/media/background1.3a88715f.png";